import { isEmpty } from '@nfctron/nexus-core';

import { EVENT_TYPE } from '@root/lib/constants/eventType';

/**
 * Returns component displayName sensitive to event type
 * @param {string} displayName
 * @param {EVENT_TYPE} eventTypeId
 * @returns {string}
 */
export const getEventTypeSensitiveComponentDisplayName = (displayName: string | undefined, eventTypeId: EVENT_TYPE) => {
	if (isEmpty(displayName)) throw new Error(`Cannot get event type sensitive component display name: displayName is empty`);
	switch (eventTypeId) {
		case EVENT_TYPE.CHIPS:
		case EVENT_TYPE.PACKAGES:
			return `${displayName}._packageEvent_`;
		default:
			return displayName;
	}
};
